var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelayLog({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 1H1V41H41V1Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 40.75C32.0755 40.75 40.75 32.0755 40.75 21.375C40.75 10.6745 32.0755 2 21.375 2C10.6745 2 2 10.6745 2 21.375C2 32.0755 10.6745 40.75 21.375 40.75Z",
    fill: "#EBECED",
    stroke: "#C8C8CB",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 9H9V34H34V9Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8125 16.8125V26.1875H26.1875V16.8125H16.8125ZM12.125 9C10.3991 9 9 10.3991 9 12.125V30.875C9 32.6009 10.3991 34 12.125 34H30.875C32.6009 34 34 32.6009 34 30.875V12.125C34 10.3991 32.6009 9 30.875 9H12.125Z",
    fill: "#007A9E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.375 39.75C31.0755 39.75 39.75 31.0755 39.75 20.375C39.75 9.67448 31.0755 1 20.375 1C9.67448 1 1 9.67448 1 20.375C1 31.0755 9.67448 39.75 20.375 39.75Z",
    fill: "white",
    stroke: "#C8C8CB",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33 8H8V33H33V8Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 14.75V25.25H26.25V14.75H15.75ZM10.5 6C8.567 6 7 7.567 7 9.5V30.5C7 32.433 8.567 34 10.5 34H31.5C33.433 34 35 32.433 35 30.5V9.5C35 7.567 33.433 6 31.5 6H10.5Z",
    fill: "#007A9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelayLog);
export default __webpack_public_path__ + "static/media/DelayLog.87e01d73.svg";
export { ForwardRef as ReactComponent };